import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const BranchSelectAutoComplete = ({ name, dataSource, floatingLabelText = "Search by Branch Name", onNewRequest }) => {
  const [searchText, setSearchText] = useState("");

  const handleUpdateInput = (searchText) => {
    setSearchText(searchText);
  };

  return (
    <div className="form-group BranchSelect">
      <Autocomplete
        freeSolo
        disableOpenOnFocus
        id={name || "BranchSelectAutoComplete"}
        searchText={searchText}
        options={dataSource || []}
        getOptionLabel={options => options.text}
        InputLabelProps={{ shrink: true }} 
        onInputChange={handleUpdateInput}
        onChange={onNewRequest}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.text}
          </li>
          )
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={floatingLabelText}
            variant="standard"
            slotProps={{
              input: {
                ...params.InputProps,
                type: 'search',
              },
            }}
          />
        )}
      />
    </div>
  );
}

export default BranchSelectAutoComplete;
